import { reactive } from "vue";
import { NodeTypeEnum } from "./nodeEnum";



//普通节点抽屉模型
export const ordinaryNodeDialog = reactive({
    dialogVisibled: false,
    dialogTitle: "",
    nodeData: {},
});

//会签节点抽屉模型
export const countersignNodeDialog = reactive({
    dialogVisibled: false,
    dialogTitle: "",
    nodeData: {},
});

//条件会签节点抽屉模型
export const conditionCountersignNodeDialog = reactive({
    dialogVisibled: false,
    dialogTitle: "",
    nodeData: {},
});

//审核流程抽屉模型
export const auditFlowDialog = reactive({
    drawerVisibled: false,
    drawerTitle: "",
    flowData: '',
});

//决策节点抽屉模型
export const decisionNodeDialog = reactive({
    dialogVisibled: false,
    dialogTitle: "",
    nodeData: {},
});

//条件节点抽屉模型
export const conditionNodeDialog = reactive({
    dialogVisibled: false,
    dialogTitle: "",
    nodeData: {},
});

//任务节点抽屉模型
export const taskNodeDialog = reactive({
    dialogVisibled: false,
    dialogTitle: "",
    nodeData: {},
});



//打开节点抽屉
export const openNodeDialog = (nodeData: any,) => {
    //打开普通节点抽屉
    if (nodeData.type === NodeTypeEnum.OrdinaryNode) {
        ordinaryNodeDialog.dialogVisibled = true;
        ordinaryNodeDialog.dialogTitle = nodeData.data.nodeName;
        ordinaryNodeDialog.nodeData = { ...nodeData.data }
    }
    //打开会签节点抽屉
    if (nodeData.type === NodeTypeEnum.CountersignNode) {
        countersignNodeDialog.dialogVisibled = true;
        countersignNodeDialog.dialogTitle = nodeData.data.nodeName;
        countersignNodeDialog.nodeData = { ...nodeData.data }
    }
    //打开条件会签节点抽屉
    if (nodeData.type === NodeTypeEnum.ConditionCountersignNode) {
        conditionCountersignNodeDialog.dialogVisibled = true;
        conditionCountersignNodeDialog.dialogTitle = nodeData.data.nodeName;
        conditionCountersignNodeDialog.nodeData = { ...nodeData.data }
    }
    //打开决策节点抽屉
    if (nodeData.type === NodeTypeEnum.DecisionNode) {
        decisionNodeDialog.dialogVisibled = true;
        decisionNodeDialog.dialogTitle = nodeData.data.nodeName;
        decisionNodeDialog.nodeData = { ...nodeData.data }
    }
    //打开条件节点抽屉
    if (nodeData.type === NodeTypeEnum.ConditionNode) {
        conditionNodeDialog.dialogVisibled = true;
        conditionNodeDialog.dialogTitle = nodeData.data.nodeName;
        conditionNodeDialog.nodeData = { ...nodeData.data }
    }
    //打开任务节点抽屉
    if (nodeData.type === NodeTypeEnum.TaskNode) {
        taskNodeDialog.dialogVisibled = true;
        taskNodeDialog.dialogTitle = nodeData.data.nodeName;
        taskNodeDialog.nodeData = { ...nodeData.data }
    }
}

//关闭节点抽屉
export const closeNodeDialog = () => {
    //关闭普通节点抽屉
    ordinaryNodeDialog.dialogVisibled = false;
    //关闭会签节点抽屉
    countersignNodeDialog.dialogVisibled = false;
    //关闭条件会签节点抽屉
    conditionCountersignNodeDialog.dialogVisibled = false;
    //关闭决策节点抽屉
    decisionNodeDialog.dialogVisibled = false;
    //关闭条件节点抽屉
    conditionNodeDialog.dialogVisibled = false;
    //关闭任务节点抽屉
    taskNodeDialog.dialogVisibled = false;
}

//设置节点数据
export const SetNodeData = (nodeData: any, elements: any) => {
    elements.nodes.filter((item: { id: string; data: any }) => {
        if (item.id === nodeData.nodeId.toString()) {
            item.data = nodeData;
        }
    });
    const nodeModeld = elements.nodes.find(
        (item: { id: string }) => item.id === nodeData.nodeId.toString()
    );
    return nodeModeld;
}